
import Vue from 'vue'

export default Vue.extend({
  name: 'RToggle',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    elaborate: {
      type: Boolean,
      default: false,
    },
    spinning: {
      type: Boolean,
      default: false,
    },
    preparing: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getClass(): String[] {
      return [
        this.disabled ? 'disabled' : '',
        this.elaborate ? 'elaborate' : '',
        this.preparing ? 'preparing' : '',
      ]
    },
  },
})
